import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import en from './en.json';
import hi from './hi.json';

const loadLanguage = async () => {
  const language = await AsyncStorage.getItem('language');
  return language || 'en';
};

const saveLanguage = async (language: string) => {
  await AsyncStorage.setItem('language', language);
};

const resources = {
  en: {
    translation: en,
  },
  hi: {
    translation: hi,
  },
};

loadLanguage().then(language => {
  i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
});

export { i18n, saveLanguage };
